import React from 'react'
import { BrowserRouter } from 'react-router-dom'
import { LanguageContextProvider } from '@cvg/react-hooks'

import localize from '@utils/localization'

import { FiltersProvider } from '@contexts/FilterContext'

import AppRoutes from '@components/AppRoutes'

const App = () => {
  return (
    <LanguageContextProvider localize={localize} storage={localStorage}>
      <FiltersProvider>
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
      </FiltersProvider>
    </LanguageContextProvider>
  )
}

export default App
